import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { HotelSearchState } from "../types/HotelSearchState";

const initialState: HotelSearchState = {
  destination: {
    label: "",
    value: "",
    countryCode: "",
    country: "",
    isProperty: false,
    city:""
  },
  checkInDate: dayjs().startOf("day").toString(),
  checkOutDate: dayjs().startOf("day").add(1, "day").toString(),
  nights: 1,
  nationality: "AE",
  currency: "AED",
  ratings: [],
  rooms: [{ adults: 1, children: [] }],
  serviceFee: {
    type: "A",
    value: 0,
  },
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchValues(state, action: PayloadAction<Partial<HotelSearchState>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setSearchValues } = searchSlice.actions;
export default searchSlice.reducer;
